<template>
  <!-- gk-drop-menu{*} -->
  <div class='menu-content'>
    <div class='menu-list' @mouseleave="onMouseOut('list')">
      <div class='item current-item' @mouseenter="onMouseOver(0)" @mouseleave="onMouseOut(0)" @click="onActiveClick()"
        :style="{background: activeItem===0?activeColor:normalColor}">{{dictionary[menulist[0]]}}
      </div>
      <div class="hidden-items" :style="{display: isOpen?'block':'none'}" v-for="(item, index) in menulist" :key="item">
        <div class='item another-item' v-if="index !== 0" @mouseenter="onMouseOver(index)"
          @mouseleave="onMouseOut(index)" @click="onNormalClick(item,index)"
          :style="{background: activeItem===index?activeColor:normalColor}">{{dictionary[item]}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['menulist', 'from'],
    components: {},
    data() {
      return {
        activeItem: 10000,
        activeColor: 'rgb(82, 82, 82)',
        normalColor: 'rgb(71, 71, 71)',
        isOpen: false,
        dictionary: {
          'WpRealEstateModel': '新房',
          'WpRealEstateModel2': '二手',
          'WpLocationModel': '地段',
          'WpAreaModel': '板块',
          'WpAdModel': '广告',
          'WpPathModel': '路径',
          'WpTagModel': '话题',
          'WpInteractModel': '交互',
          'WpRecordModel': '收藏',
          'WpUserModel': '用户',
          'WpUpdateCheckModel': '审核',
          'WpApartmentModel': '户型',
          'WpArticleModel': '文章',
          'WpBackupModel': '备份',
          'WpVoiceModel': '留言',
          'WpTalkModel': '对话',
          'WpWantModel': '评测',
          'AreaPlanModel': '土规',
          'SubwayModel': '地铁',
          'WpSystemModel': '系统',
          'WpWarnModel': '疫情',
          'WpActivityModel': '活动',
          'LandDealModel': '土拍',
          'WpLabelModel': '标签',
          'HighwayModel': '高架',
          'WpTopicModel': '话题',
          'WpCrlistModel': '合集',

          '页面导航': '页面导航',
          '入驻审核': '入驻审核',
          '资料审核': '资料审核',
          '更新检查': '加贡献分',
          '热门楼盘': '热门楼盘',
          '热门版块': '热门版块',
          '投票管理': '投票管理',
          '问答管理': '问答管理',
          '户型工具': '户型工具',
          '绘制地铁': '绘制地铁',
          '绘制学区': '绘制学区',
          '绘制板块': '绘制板块',
          '楼盘集合': '数据统计',
          '楼市提问': '楼市提问',
          '地图菜单': '地图菜单',
          '测试户型': '测试户型',
          '内容运营': '内容运营',
          '其它操作': '其它操作',
          '疫情标记': '最近留言',
          '我要评测': '我要评测'
        }
      }
    },
    created() {

    },
    computed: {},
    methods: {
      onMouseOver(data) {
        this.activeItem = data
      },
      onMouseOut(data) {
        if (data === 'list') {
          this.isOpen = false
          this.activeItem = 10000
        }
      },
      onActiveClick() {
        this.isOpen = !this.isOpen
      },
      onNormalClick(item, index) {
        let message = {
          'from': this.from,
          'oper': 'click',
          'dataContent': item,
          'index': index
        }
        this.onMouseOut('list')
        this.$emit('childOper', message)
      }
    }
  }

</script>
<style scoped>

  .menu-list {
    background: rgb(71, 71, 71);
    text-align: center;
    width: 100px;
    /* display: inline-block; */
  }

  .item {
    padding: 12px 15px;
    height: 40px;
    width: 100px;
    /* display: inline-block; */
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: azure;
    background: rgb(71, 71, 71);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
  }

  .menu-content li {
    float: left;
  }

  .hidden-items {
    clear: both;
  }

  .hidden-items a {
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/DbMenu.vue